(function () {
  'use strict';
  if (window.__buyboxRedesignInit) return;
  window.__buyboxRedesignInit = true;

  var KACHING_SELECTOR = '.shopify-block.shopify-app-block';
  var KACHING_SCRIPT_SELECTOR =
    'script.kaching-bundles-deal-block-settings, script.kaching-bundles-product';

  // ---------- Config from snippet ----------

  function getAudienceConfig() {
    var cfg = document.querySelector('script[data-buybox-audience-config]');
    var empty = { newCustomerDealBarIds: [] };
    if (!cfg) return empty;
    try {
      var data = JSON.parse(cfg.textContent);
      return {
        newCustomerDealBarIds: Array.isArray(data.newCustomerDealBarIds)
          ? data.newCustomerDealBarIds
          : []
      };
    } catch (e) {
      return empty;
    }
  }

  // ---------- Bundle helpers ----------

  function getBundleEffectiveId(wrapper) {
    if (!wrapper) return null;
    var manual = wrapper.getAttribute('manual-deal-block-id');
    if (manual) return manual;
    var inner = wrapper.querySelector('[deal-block-id], [data-deal-block-id]');
    if (!inner) return null;
    return (
      inner.getAttribute('deal-block-id') ||
      inner.getAttribute('data-deal-block-id') ||
      null
    );
  }

  function findAllBundles() {
    return document.querySelectorAll('kaching-bundle');
  }

  // Match bundle by its containing new-customer deal_bar_ids.
  function findNewCustomerBundleId(newBarIds) {
    if (!newBarIds || !newBarIds.length) return null;
    for (var i = 0; i < newBarIds.length; i++) {
      var id = newBarIds[i];
      var bar = document.querySelector(
        '[data-deal-bar-id="' + CSS.escape(id) + '"]'
      );
      if (bar) {
        var wrapper = bar.closest('kaching-bundle');
        if (wrapper) return getBundleEffectiveId(wrapper);
      }
    }
    return null;
  }

  // ---------- Per-Kaching-bundle controller (for pill filtering) ----------

  // Main product quantity for a deal bar (productGID === "default").
  function getDealBarMainQuantity(activeId) {
    var scripts = document.querySelectorAll(
      'script.kaching-bundles-deal-block-settings'
    );
    for (var i = 0; i < scripts.length; i++) {
      try {
        var cfg = JSON.parse(scripts[i].textContent);
        var bars = cfg.dealBars || [];
        for (var j = 0; j < bars.length; j++) {
          if (bars[j].id !== activeId) continue;
          var products = bars[j].bundleProducts || [];
          for (var k = 0; k < products.length; k++) {
            if (products[k].productGID === 'default') {
              return products[k].quantity;
            }
          }
          // quantity-break bars put it at top level
          if (typeof bars[j].quantity === 'number') return bars[j].quantity;
        }
      } catch (e) {}
    }
    return null;
  }

  // Update theme's qty input when switching bars programmatically
  // (Kaching only does this on real user clicks).
  function updateFormQuantity(qty) {
    if (!qty) return;
    var inputs = document.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      // skip cart-page qty fields
      if (!inputs[i].closest('form, product-form')) continue;
      inputs[i].value = qty;
      inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
      inputs[i].dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function ensureDealBarSelected(kachingEl, activeId) {
    if (!kachingEl || !activeId) return false;

    var block = kachingEl.querySelector('kaching-bundles-block');
    if (!block) return false;
    if (block.selectedDealBarId === activeId) return true;

    block.selectedDealBarId = activeId;
    // Skip dispatching radio 'change' — it spams /cart/add.js previews in a
    // loop with our MutationObserver.
    updateFormQuantity(getDealBarMainQuantity(activeId));

    return true;
  }

  // ---------- Global state ----------

  var state = {
    currentDealBlockId: null,
    newCustomerBundleId: null,
    newCustomerDealBarIds: [],
    activePillId: null,
    initialSelectDone: false,
    forceNewCustomer: false
  };

  function correctThemePriceText() {
    if (!state.currentDealBlockId) return null;
    var bundles = findAllBundles();
    for (var i = 0; i < bundles.length; i++) {
      var w = bundles[i];
      if (getBundleEffectiveId(w) !== state.currentDealBlockId) continue;
      if (w.style.display === 'none') continue;
      // Prefer Lit property (synchronous) over --selected class (lags one render).
      var block = w.querySelector('kaching-bundles-block');
      var activeBarId = block && block.selectedDealBarId;
      var selected = activeBarId
        ? w.querySelector('[data-deal-bar-id="' + CSS.escape(activeBarId) + '"]')
        : w.querySelector('.kaching-bundles__bar--selected[data-deal-bar-id]');
      if (!selected) continue;
      // Horizontal (returning) → secondary row has bundle total.
      // Vertical (new-customer) → price is direct child of .bar-pricing.
      var priceEl =
        selected.querySelector(
          '.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price'
        ) ||
        selected.querySelector(
          '.kaching-bundles__bar-pricing > .kaching-bundles__bar-price'
        ) ||
        selected.querySelector('.kaching-bundles__bar-price');
      if (!priceEl) continue;
      var clone = priceEl.cloneNode(true);
      var prefix = clone.querySelector('.buybox-gesamt-prefix');
      if (prefix) prefix.parentElement.removeChild(prefix);
      return (clone.textContent || '').trim() || null;
    }
    return null;
  }

  function fixThemePrice() {
    var want = correctThemePriceText();
    if (!want) return;
    // .price-item--last is excluded — the theme reuses it for the unit
    // price ("€10,98 / KG"). <s> = strikethrough compare-at, keep as-is.
    var current = document.querySelectorAll(
      '.price-item--regular, .price-item--sale'
    );
    for (var i = 0; i < current.length; i++) {
      var el = current[i];
      if (el.closest('kaching-bundle')) continue;
      if (el.tagName === 'S' || el.closest('s')) continue;
      if (el.textContent.trim() !== want) {
        el.textContent = want;
      }
    }
  }

  // ---------- Visibility ----------

  // Outermost section-block wrapper so hiding collapses the full slot.
  function getBundleSectionWrapper(bundle) {
    return (
      bundle.closest('.block') ||
      bundle.closest('.shopify-app-block') ||
      bundle
    );
  }

  function setBundleVisible(bundle, visible) {
    var wrapper = getBundleSectionWrapper(bundle);
    wrapper.style.display = visible ? '' : 'none';
  }

  function applyBundleVisibility() {
    var toggleTargets = [];
    var variants = document.querySelectorAll('[data-target-deal-block-id]');
    for (var k = 0; k < variants.length; k++) {
      var t = variants[k].getAttribute('data-target-deal-block-id');
      if (t) toggleTargets.push(t);
    }

    var bundles = findAllBundles();
    for (var i = 0; i < bundles.length; i++) {
      var w = bundles[i];
      var manualId = w.getAttribute('manual-deal-block-id');
      var effectiveId = getBundleEffectiveId(w);

      // Hide manual bundles from another product's setup
      if (manualId && manualId.length > 0 && toggleTargets.indexOf(manualId) === -1) {
        setBundleVisible(w, false);
        continue;
      }

      if (toggleTargets.length > 0 && effectiveId) {
        setBundleVisible(w, effectiveId === state.currentDealBlockId);
      }
    }
  }

  function applyToggleVisibility() {
    var variants = document.querySelectorAll('[data-target-deal-block-id]');
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var target = v.getAttribute('data-target-deal-block-id');
      // Hide variant pointing to the bundle we're already on.
      v.style.display = target === state.currentDealBlockId ? 'none' : '';
    }
  }

  function applyPillBlockVisibility() {
    var pills = document.querySelectorAll('[data-buybox-pills]');
    var show =
      state.newCustomerBundleId &&
      state.currentDealBlockId === state.newCustomerBundleId;
    for (var i = 0; i < pills.length; i++) {
      pills[i].style.display = show ? '' : 'none';
    }
  }

  // In the new-customer bundle, show only the bar matching the active pill.
  function applyPillFilter() {
    if (!state.newCustomerBundleId) return;
    if (state.currentDealBlockId !== state.newCustomerBundleId) return;

    var newBundle = null;
    var bundles = findAllBundles();
    for (var i = 0; i < bundles.length; i++) {
      if (getBundleEffectiveId(bundles[i]) === state.newCustomerBundleId) {
        newBundle = bundles[i];
        break;
      }
    }
    if (!newBundle) return;

    var activeId = state.activePillId;
    var bars = newBundle.querySelectorAll('[data-deal-bar-id]');
    if (!bars.length) return;

    for (var j = 0; j < bars.length; j++) {
      var b = bars[j];
      var bid = b.getAttribute('data-deal-bar-id');
      if (activeId) {
        b.style.display = bid === activeId ? '' : 'none';
      } else {
        b.style.display = '';
      }
    }

    if (activeId && (!state.initialSelectDone || state.userInitiated)) {
      ensureDealBarSelected(newBundle, activeId);
      state.initialSelectDone = true;
      state.userInitiated = false;
    }
  }

  // Restructure returning-bundle cards to match Figma: move savings pill
  // into main price row, prepend "Gesamt: " to secondary price.
  function restyleReturningCards() {
    if (!document.querySelector('[data-target-deal-block-id]')) return;

    var bars = document.querySelectorAll(
      '.kaching-bundles__block--horizontal .kaching-bundles__bar'
    );
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];

      // Move savings label next to the price
      var label = bar.querySelector('.kaching-bundles__bar-label');
      var mainPriceRow = bar.querySelector(
        '.kaching-bundles__bar-pricing-row--main'
      );
      if (label && mainPriceRow && label.parentElement !== mainPriceRow) {
        mainPriceRow.appendChild(label);
      }

      // After audience toggle, Kaching re-renders price rows with a fresh
      // inline unit-label; drop our stale .buybox-unit-row to avoid dupes.
      var stalePriceUnitLabel = bar.querySelector(
        '.kaching-bundles__bar-price .kaching-bundles__bar-price__unit-label'
      );
      if (stalePriceUnitLabel) {
        var staleRows = bar.querySelectorAll('.buybox-unit-row');
        for (var u = 0; u < staleRows.length; u++) {
          staleRows[u].parentElement.removeChild(staleRows[u]);
        }
      }

      // Move "pro Stück" into its own row between main and secondary.
      var unitLabel = bar.querySelector(
        '.kaching-bundles__bar-price__unit-label'
      );
      var pricing = bar.querySelector('.kaching-bundles__bar-pricing');
      var secondaryRow = bar.querySelector(
        '.kaching-bundles__bar-pricing-row--secondary'
      );
      if (
        unitLabel &&
        pricing &&
        !unitLabel.closest('.buybox-unit-row')
      ) {
        var unitRow = document.createElement('div');
        unitRow.className = 'buybox-unit-row';
        unitRow.appendChild(unitLabel);
        if (secondaryRow) {
          pricing.insertBefore(unitRow, secondaryRow);
        } else {
          pricing.appendChild(unitRow);
        }
      }

      // Prepend "Gesamt: " — check for the span (not a data-attr) since
      // Kaching may replace .bar-price wholesale and lose the attribute.
      var secondaryPrice = bar.querySelector(
        '.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price'
      );
      if (
        secondaryPrice &&
        !secondaryPrice.querySelector('.buybox-gesamt-prefix')
      ) {
        var prefix = document.createElement('span');
        prefix.className = 'buybox-gesamt-prefix';
        prefix.textContent = 'Gesamt: ';
        secondaryPrice.insertBefore(prefix, secondaryPrice.firstChild);
      }
    }
  }

  function sync() {
    applyBundleVisibility();
    applyToggleVisibility();
    applyPillBlockVisibility();
    applyPillFilter();
    restyleReturningCards();
    maybeClearResolving();
    // audience switching doesn't trigger Kaching's price hook
    fixThemePrice();
  }

  // Click Einmaliger Kauf (first subscription bar) if not already on it.
  // Subscription bars have no radio input — the bar itself is role="button".
  function resetSubscriptionToOneTime() {
    var container = document.querySelector('.kaching-bundles__subscriptions');
    if (!container) return;
    var first = container.querySelector('.kaching-bundles__bar');
    if (!first || first.classList.contains('kaching-bundles__bar--selected')) return;
    first.click();
  }

  // Reveal manual bundles once the correct one is settled. With
  // ?new_customer=true, wait until the new-customer bundle is selected.
  function maybeClearResolving() {
    var html = document.documentElement;
    if (!html.classList.contains('buybox-resolving')) return;
    var ready =
      !state.forceNewCustomer ||
      (state.newCustomerBundleId &&
        state.currentDealBlockId === state.newCustomerBundleId);
    if (ready) html.classList.remove('buybox-resolving');
  }

  // ---------- Initialization ----------

  function detectAndInit() {
    var cfg = getAudienceConfig();
    state.newCustomerDealBarIds = cfg.newCustomerDealBarIds;

    // Kaching may not have rendered yet — observer will retry.
    state.newCustomerBundleId = findNewCustomerBundleId(cfg.newCustomerDealBarIds);

    // ?new_customer=true → force new-customer; else → first bundle in DOM.
    try {
      state.forceNewCustomer =
        new URL(window.location.href).searchParams.get('new_customer') === 'true';
    } catch (e) {}

    if (!state.currentDealBlockId) {
      if (state.forceNewCustomer && state.newCustomerBundleId) {
        state.currentDealBlockId = state.newCustomerBundleId;
      } else {
        var first = document.querySelector('kaching-bundle');
        if (first) state.currentDealBlockId = getBundleEffectiveId(first);
      }
    }

    // First .is-active pill (first pill by default)
    var activePill = document.querySelector(
      '[data-buybox-pills] .buybox-pills__pill.is-active'
    );
    state.activePillId = activePill
      ? activePill.getAttribute('data-target-deal-bar-id')
      : null;

    sync();
  }

  // ---------- Event wiring ----------

  function bindToggleClicks() {
    var btns = document.querySelectorAll('[data-buybox-audience-toggle]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.__buyboxBound) continue;
      btn.__buyboxBound = true;
      btn.addEventListener('click', function (e) {
        var variant = e.target.closest('[data-target-deal-block-id]');
        if (!variant) {
          // Fallback: visible variant inside this button
          variant = e.currentTarget.querySelector(
            '[data-target-deal-block-id]:not([style*="display: none"])'
          );
        }
        if (!variant) return;
        var target = variant.getAttribute('data-target-deal-block-id');
        if (!target || target === state.currentDealBlockId) return;
        // Subscription toggle only applies to returning customer
        if (state.newCustomerBundleId && target === state.newCustomerBundleId) {
          resetSubscriptionToOneTime();
        }
        state.currentDealBlockId = target;
        state.userInitiated = true;
        sync();
      });
    }
  }

  function bindPillClicks() {
    var pillBlocks = document.querySelectorAll('[data-buybox-pills]');
    for (var i = 0; i < pillBlocks.length; i++) {
      var pe = pillBlocks[i];
      if (pe.__buyboxBound) continue;
      pe.__buyboxBound = true;
      pe.addEventListener('click', function (e) {
        var pill = e.target.closest('.buybox-pills__pill');
        if (!pill) return;
        var container = pill.closest('[data-buybox-pills]');
        if (!container) return;
        var all = container.querySelectorAll('.buybox-pills__pill');
        for (var j = 0; j < all.length; j++) {
          all[j].classList.remove('is-active');
          all[j].setAttribute('aria-selected', 'false');
        }
        pill.classList.add('is-active');
        pill.setAttribute('aria-selected', 'true');
        state.activePillId = pill.getAttribute('data-target-deal-bar-id');
        state.userInitiated = true;
        sync();
      });
    }
  }

  function attachKachingObservers() {
    var blocks = document.querySelectorAll(KACHING_SELECTOR);
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.__buyboxObserver) continue;
      if (!b.querySelector(KACHING_SCRIPT_SELECTOR)) continue;
      b.classList.add('buybox-kaching-controlled');
      var obs = new MutationObserver(function () {
        // Retry new-customer detection if not known yet.
        if (!state.newCustomerBundleId) {
          state.newCustomerBundleId = findNewCustomerBundleId(
            state.newCustomerDealBarIds
          );
          if (state.newCustomerBundleId) {
            // Honor ?new_customer=true now that we know which is which.
            if (
              state.forceNewCustomer &&
              state.currentDealBlockId !== state.newCustomerBundleId
            ) {
              state.currentDealBlockId = state.newCustomerBundleId;
            } else if (!state.currentDealBlockId) {
              state.currentDealBlockId = state.newCustomerBundleId;
            }
          }
        }
        sync();
      });
      obs.observe(b, { childList: true, subtree: true });
      b.__buyboxObserver = obs;
    }
  }

  // ---------- Bootstrap ----------

  // Active bundle's nanoId + bar id + main qty, for the cart/add rewriter.
  function getActiveBundleInfo() {
    var bundles = findAllBundles();
    for (var i = 0; i < bundles.length; i++) {
      var w = bundles[i];
      var id = getBundleEffectiveId(w);
      if (id !== state.currentDealBlockId) continue;
      var litBlock = w.querySelector('kaching-bundles-block');
      if (!litBlock) continue;
      var activeBarId = litBlock.selectedDealBarId;
      if (!activeBarId) continue;

      var scripts = document.querySelectorAll(
        'script.kaching-bundles-deal-block-settings'
      );
      for (var j = 0; j < scripts.length; j++) {
        try {
          var cfg = JSON.parse(scripts[j].textContent);
          if (cfg.id !== id) continue;
          var bars = cfg.dealBars || [];
          for (var k = 0; k < bars.length; k++) {
            if (bars[k].id !== activeBarId) continue;
            var qty = null;
            var products = bars[k].bundleProducts || [];
            for (var p = 0; p < products.length; p++) {
              if (products[p].productGID === 'default') {
                qty = products[p].quantity;
                break;
              }
            }
            if (qty === null && typeof bars[k].quantity === 'number') {
              qty = bars[k].quantity;
            }
            return {
              dealNanoId: cfg.nanoId,
              barId: activeBarId,
              mainQuantity: qty
            };
          }
        } catch (e) {}
      }
    }
    return null;
  }

  // Rewrite /cart/add FormData to the active bundle — Kaching's form
  // picks the wrong one when multiple bundles exist on the page.
  function interceptCartAdd() {
    if (window.__buyboxFetchPatched) return;
    window.__buyboxFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var opts = arguments[1] || {};
      var isMainCartAdd =
        typeof url === 'string' &&
        /\/cart\/add(\.js)?(\?|$)/.test(url) &&
        url.indexOf('kaching_bundles=true') === -1;
      if (isMainCartAdd) {
        var info = getActiveBundleInfo();
        if (info && opts.body instanceof FormData) {
          if (opts.body.has('quantity') && info.mainQuantity) {
            opts.body.set('quantity', String(info.mainQuantity));
          }
          if (opts.body.has('properties[__kaching_bundles]')) {
            opts.body.set(
              'properties[__kaching_bundles]',
              JSON.stringify({
                deal: info.dealNanoId,
                main: true,
                bid: info.barId
              })
            );
          }
        }
      }
      return orig.apply(this, [url, opts]);
    };
  }

  // Body class to scope redesign CSS (subscription toggle restyle, etc.)
  // to products that opted in — i.e. have toggle entries or pills.
  function flagRedesignActive() {
    if (
      document.querySelector('[data-buybox-pills]') ||
      document.querySelector('[data-target-deal-block-id]')
    ) {
      document.body.classList.add('buybox-redesign-active');
    }
  }

  function bootstrap() {
    flagRedesignActive();
    detectAndInit();
    bindToggleClicks();
    bindPillClicks();
    attachKachingObservers();
    interceptCartAdd();
    pinPriceDuringInit();
    // Safety net: never leave bundles invisible if resolution fails.
    setTimeout(function () {
      document.documentElement.classList.remove('buybox-resolving');
    }, 1500);
  }

  // Pin the theme price to the visible bundle's selected bar. The hidden
  // bundle's updateNativePrice would otherwise win and show the wrong total.
  // fixThemePrice is idempotent, so user clicks aren't fought.
  function pinPriceDuringInit() {
    var obs = new MutationObserver(fixThemePrice);
    obs.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Brute-force backup for the volatile first 5 seconds.
    var iv = setInterval(fixThemePrice, 50);
    fixThemePrice();
    setTimeout(function () {
      clearInterval(iv);
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', bootstrap);
  document.addEventListener('shopify:block:select', bootstrap);
})();
